import { render, staticRenderFns } from "./StoreRolesTable.vue?vue&type=template&id=559bc072&"
import script from "./StoreRolesTable.vue?vue&type=script&lang=js&"
export * from "./StoreRolesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports